module.exports = __webpack_public_path__ + "img/event-2.7a39e6d.jpg";